import React from "react";
import { useSelector } from "react-redux";
import { PageLayout } from "../../../components";
import { useSourceSystem } from "../../../hooks/useSourceSystem";
import { getIsBlockedRegistration } from "../../../store/selectors";

export default function UnableToValueError() {
  const { sourceSystem } = useSourceSystem();
  const isBlocked = useSelector(getIsBlockedRegistration);

  const {
    stepPercentage,
    errorMain,
    errorHint,
    primaryButtonText,
    secondaryButtonText,
    showAltButton,
    errorBlocked,
    errorBlockedHint
  } = sourceSystem.unableToValueError.unableToValueContent;

  return (
    <PageLayout>
      <PageLayout.Header title="Registration" step={stepPercentage} />
      <div className="ch-container ch-mt--4 md:ch-width--4 sm:ch-width--5 ch-width--12 sl:ch-width--8 ">
        {isBlocked ? (
          <div className="ch-alert ch-alert--danger ch-fs--3 ">
            <p className="ch-text--bold">{errorBlocked}</p>
            <p className="ch-fs--2">{errorBlockedHint}</p>
          </div>
        ) : (
          <div
            className="ch-alert ch-alert--warning ch-fs--3 "
            style={{ border: "solid 1px orange" }}
          >
            <p className="ch-text--bold">{errorMain}</p>
            <p>{errorHint}</p>
          </div>
        )}
      </div>

      <div className="reg-error-page-layout--bottom-fixed ch-bg--grey-1 sm:ch-mt--10">
        <button
          className="ch-btn ch-btn--success ch-btn--block ch-mh--auto sm:ch-width--6 md:ch-width--5 ch-width--12 lg:ch-width--4"
          onClick={() =>
            sourceSystem.unableToValueError.onClickUnableToValuePrimary()
          }
        >
          {primaryButtonText}
        </button>
        {showAltButton && (
          <button
            className="ch-btn ch-btn--block ch-mh--auto sm:ch-width--6 md:ch-width--5 ch-width--12 lg:ch-width--4"
            onClick={() =>
              sourceSystem.unableToValueError.onClickUnableToValueSecondary()
            }
          >
            {secondaryButtonText}
          </button>
        )}
      </div>
    </PageLayout>
  );
}
